export default "__VITE_ASSET__DfbxnVZW__"